import { IAddress } from '../types';

interface IApiAddressResults {
  adresseid: string;
  gatenavn: string;
  husnrbokstav: string;
  postnr: string;
  poststed: string;
  kilde: string;
}

const locationSearch = async (address: string) => {
  return fetch(`/utils/geodata.php?service=autocomplete&adr=${address}&zip=`)
    .then((response) => {
      if (!response.ok) {
        throw Error('Somthing went wrong with the API call');
      } else {
        return response.json();
      }
    })
    .then((data) => {
      const reducedData = data.hits.reduce((hits: [IAddress], value: IApiAddressResults) => {
        if (value && value.kilde === 'Adresse') {
          hits.push({
            id: value.adresseid,
            street: value.gatenavn,
            num: value.husnrbokstav,
            zip: value.postnr,
            city: value.poststed,
          });
        }
        return hits;
      }, []);
      return reducedData;
    })
    .catch((error) => {
      return {};
    });
};

export default locationSearch;
